var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"w-2/5 m-auto",attrs:{"src":require("@/assets/images/No-data.svg"),"alt":""}}),_c('p',{staticClass:"font-semibold text-center text-xl"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }